import React, { useState } from "react";
import { styled } from "styled-components";
import Label from "@cs/components/src/Label";
import Input from "@cs/components/src/Input";
import cronstrue from "cronstrue";

interface Props {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

const InputRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  > * {
    flex-grow: 1;
  }

  > * + * {
    margin-left: 10px;
  }
`;

const Wrapper = styled.div`
  background-color: var(--dark200);
  padding: 10px;
  margin-bottom: 20px;
`;

const Description = styled.div`
  color: var(--dark700);
  margin-top: -15px;
  font-size: 13px;
`;

const DocLink = styled.a`
  color: var(--blue300);
  padding-left: 5px;
`;

const CronInput = (props: Props) => {
  const { value, onChange, required } = props;

  const parts = value.trim().split(" ");

  const [minute, setMinute] = useState(parts[0]);
  const [hour, setHour] = useState(parts[1]);
  const [week, setWeek] = useState(parts[4]);

  const updatePart = (key: "minute" | "hour" | "week", value: string) => {
    const newParts = [...parts];
    if (key === "minute") {
      setMinute(value);
      if (value) {
        newParts[0] = value;
      }
    } else if (key === "hour") {
      setHour(value);
      if (value) {
        newParts[1] = value;
      }
    } else if (key === "week") {
      setWeek(value);
      if (value) {
        newParts[4] = value;
      }
    }
    onChange(newParts.join(" "));
  };

  let cronLabel = "Invalid expression";
  try {
    if (value.trim().split(/ +/g).length !== 6) {
      throw new Error();
    }
    cronLabel = cronstrue.toString(value) + " (America/Chicago)";
  } catch {}

  return (
    <div>
      <Label
        label={
          <>
            <span>Cron</span>
            <DocLink
              href="https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-cron-expressions.html"
              target="_blank"
              rel="noreferrer"
              tabIndex={-1}
            >
              - Documentation
            </DocLink>
          </>
        }
        required={required}
      />
      <Wrapper>
        <InputRow>
          <Input
            label="Minute"
            value={minute}
            onChange={(value) => updatePart("minute", value)}
          />
          <Input
            label="Hour"
            value={hour}
            onChange={(value) => updatePart("hour", value)}
          />
          <Input
            label="Day of Week"
            value={week}
            onChange={(value) => updatePart("week", value)}
          />
        </InputRow>
        <Description>{cronLabel}</Description>
      </Wrapper>
    </div>
  );
};

export default CronInput;
